import styled from 'styled-components';

import type {Nullish} from 'shared/web';

import {getSwatchColor} from './utils/getSwatchColor';

export type ColourSwatchProps = {
  name: string;
  hex?: string | Nullish;
  size?: 'dot' | 'tile';
};

type SwatchSize = NonNullable<ColourSwatchProps['size']>;

const Swatch = styled.span<{$color: string; $size: SwatchSize}>`
  display: inline-block;
  flex-shrink: 0;
  /* tile height matches the two-line name + price block, so both edges stay flush */
  width: ${({theme, $size}) => theme.getSize($size === 'dot' ? 3 : 11)};
  height: ${({theme, $size}) => theme.getSize($size === 'dot' ? 3 : 11)};
  border-radius: ${({theme, $size}) =>
    $size === 'dot' ? theme.radii.circular : theme.radii.small};
  background: ${({$color}) => $color};
  box-shadow: inset 0 0 0 1px ${({theme}) => theme.colors.palettes.neutral[900][20]};
`;

export function ColourSwatch(props: ColourSwatchProps) {
  return (
    <Swatch
      aria-hidden
      $color={getSwatchColor(props.name, props.hex)}
      $size={props.size ?? 'tile'}
    />
  );
}
